module.exports = __webpack_public_path__ + "media/images/ac_templates/201/snd-35c22dbf13e35954bb37cccc04982515.jpg";